import { getFriendlyDateLabel } from "../../utils/utils-file";

const CameraFilter = ({
  metadataProcessed,
  images,
  cameraFilter,
  setCameraFilter,
  cameraOptions,
  allCount,
}) => {
  if (!metadataProcessed) {
    return (
      <div className="camera-filter-loading">
        <span>{images.length === 0 ? "No photos or videos found." : "Loading camera zones..."}</span>
      </div>
    );
  }

  if (images.length === 0) return null;

  return (
    <div className="camera-filter-buttons">
      <div className="camera-buttons-desktop">
        {cameraOptions.length > 1 && (
          <button
            className={`camera-btn ${cameraFilter === "all" ? "active" : ""}`}
            onClick={() => setCameraFilter("all")}
          >
            All <span className="filter-count">{allCount}</span>
          </button>
        )}
        {cameraOptions.map(({ camera, count }, index) => (
          <button
            key={camera}
            className={`camera-btn ${cameraFilter === camera ? "active" : ""}`}
            onClick={() => setCameraFilter(camera)}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            {getFriendlyDateLabel(camera)} <span className="filter-count">{count}</span>
          </button>
        ))}
      </div>

      <select
        className="camera-select-mobile"
        value={cameraFilter}
        onChange={(e) => setCameraFilter(e.target.value)}
      >
        {cameraOptions.length > 1 && (
          <option value="all">All Cameras ({allCount})</option>
        )}
        {cameraOptions.map(({ camera, count }) => (
          <option key={camera} value={camera}>
            {getFriendlyDateLabel(camera)} ({count})
          </option>
        ))}
      </select>
    </div>
  );
};

export default CameraFilter;
